<template>
  <v-container>
    <p>This website is for personal use. Please contact Brian Cho for demo.</p>
    <div class="tw-float-right">
      <v-btn
        @click="googleSignIn"
        color="primary"
        elevation="2"
        v-if="!isSignedIn"
        >Sign In</v-btn
      >
      <v-btn
        @click="googleSignOut"
        color="primary"
        elevation="2"
        v-if="isSignedIn"
        >Sign Out</v-btn
      >
    </div>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import {
  getAuth,
  signInWithPopup,
  signOut,
  GoogleAuthProvider,
  onAuthStateChanged,
} from "firebase/auth";

export default defineComponent({
  name: "HomeView",
  setup() {
    const isSignedIn = ref<Boolean>(false);
    const auth = getAuth();
    onAuthStateChanged(auth, (user: any) => {
      isSignedIn.value = user;
    });
    const googleSignIn = () => {
      const provider = new GoogleAuthProvider();
      signInWithPopup(auth, provider)
        .then((result) => {
          const credential = GoogleAuthProvider.credentialFromResult(result);
          const token = credential && credential.accessToken;
          const user = result.user;
          console.log(token);
          console.log(user);
        })
        .catch((error) => {
          console.error(error);
        });
    };

    const googleSignOut = () => {
      signOut(auth)
        .then(() => {})
        .catch((error) => {
          console.error(error);
          alert("Something went wrong");
        });
    };
    return { googleSignIn, googleSignOut, isSignedIn };
  },
});
</script>
